import type { HistoryTone } from '@/Ship/Components/History'

/**
 * Коди подій історії співробітника — рівно перелік ADR 041
 * (`backend/web/src/Ship/Database/Enum/UserHistoryEvent.php`, `SPEC-005` §3.5).
 *
 * Стрічка малює `label ?? event`, тож код без підпису витік би користувачу
 * голим. Мапу звіряє з беком вартовий «кожен код події історії з бека має
 * підпис на фронті» (`Ship/Helpers/architectureGuard.test.ts`).
 */
export type UserHistoryEventCode = 'user_roles_changed' | 'user_status_changed' | 'user_departments_changed'

export interface UserHistoryEventInfo {
    label: string
    tone: HistoryTone
}

export const HISTORY_EVENT_MAP: Record<UserHistoryEventCode, UserHistoryEventInfo> = {
    user_roles_changed: { label: 'Змінено ролі', tone: 'purple' },
    user_status_changed: { label: 'Змінено статус', tone: 'orange' },
    user_departments_changed: { label: 'Змінено відділи', tone: 'neutral' },
}

export const isUserHistoryEvent = (code: string): code is UserHistoryEventCode => code in HISTORY_EVENT_MAP
